const routes = [
    {
        path: "/student/semesters",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentsemester_index"
        }
    }
];

export default routes;
